import {Component, OnInit} from '@angular/core';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {VoilaUserService} from '@services/voila-user.service';
import {ToolbarComponent} from '@app/toolbar/toolbar.component';
import {HeaderComponent} from '@app/header/header.component';
import {MinPrivilegeDirective} from '@util/directives/min-privilege.directive';
import {MarkantElementsModule} from '@markant/elements-angular';
import {RouteBuilder} from '@util/route-builder';
import {StatsService} from '@services/stats.service';
import {MaOverviewStatsResource} from '@services/resource/ma-overview-stats-resource';

@Component({
  selector: 'app-ma-dashboard',
  templateUrl: './ma-dashboard.component.html',
  styleUrls: ['./ma-dashboard.component.scss'],
  standalone: true,
  imports: [ToolbarComponent, HeaderComponent, RouterLinkActive, RouterLink, MinPrivilegeDirective, MarkantElementsModule, RouterOutlet],
})
export class MaDashboardComponent implements OnInit {
  stats?: MaOverviewStatsResource;

  constructor(
    private readonly router: Router,
    readonly userService: VoilaUserService,
    private readonly statsService: StatsService,
  ) {}

  ngOnInit() {
    this.statsService.getMaOverviewStats().subscribe((r) => {
      this.stats = r;
    });
  }

  get routes() {
    return {
      welcome: RouteBuilder.app().maDashboard().welcome().build(),
      handelspartner: RouteBuilder.app().maDashboard().handelspartner().build(),
      cycles: RouteBuilder.app().maDashboard().cycles().build(),
      products: RouteBuilder.app().maDashboard().products().build(),
      voting: RouteBuilder.app().maDashboard().voting().build(),
    };
  }

  pickedUrl(buttonName: string) {
    switch (buttonName.toLowerCase()) {
      case 'übersicht':
        if (this.router.url == this.routes.welcome) {
          return 'primary';
        }
        return 'secondary';

      case 'handelspartner':
        if (this.router.url == this.routes.handelspartner) {
          return 'primary';
        }
        return 'secondary';

      case 'termine':
        if (this.router.url == this.routes.cycles) {
          return 'primary';
        }
        return 'secondary';

      case 'start-ups':
        if (this.router.url.startsWith(this.routes.products)) {
          return 'primary';
        }
        return 'secondary';

      case 'abstimmung':
        if (this.router.url.startsWith(this.routes.voting)) {
          return 'primary';
        }
    }
    return 'secondary';
  }

  private currentOrRecentCycleUuid(): string {
    return this.stats?.applications?.cycle.uuid || 'all';
  }

  private DEFAULT_QUERY_PARAMS = {
    productGroupKey: 'all',
    statusIn: 'all',
    searchProductSort: 'productCreatedDesc',
    cycleFilter: 'all',
    verdictFilter: 'all',
    text: '',
    favorite: 'all',
  };

  get queryParamsStartUp() {
    return {
      ...this.DEFAULT_QUERY_PARAMS,
      cycleFilter: this.currentOrRecentCycleUuid(),
    };
  }

  get queryParamsAbstimmung() {
    return {
      ...this.DEFAULT_QUERY_PARAMS,
      cycleFilter: this.currentOrRecentCycleUuid(),
      statusIn: ['approved', 'invited', 'notinvited'],
      searchProductSort: 'votesDesc',
    };
  }
}
